import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TrademeCoreUiPipeModule } from '@classifieds-sell/shared';
import {
    TgButtons2Module,
    TgGridModule,
    TgIconBasicInfoFramedModule,
    TgInfoBoxModule,
    TgRackModule
} from '@trademe/tangram';
import { SummaryPageValidationSummarySectionComponent } from './summary-page-validation-summary-section.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        TgGridModule,
        TgRackModule,
        TrademeCoreUiPipeModule,
        TgInfoBoxModule,
        TgIconBasicInfoFramedModule,
        TgButtons2Module
    ],
    declarations: [SummaryPageValidationSummarySectionComponent],
    exports: [SummaryPageValidationSummarySectionComponent]
})
export class SummaryPageValidationSummarySectionModule {}
